import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=536d8c3b&scoped=true&"
import script from "./UserView.vue?vue&type=script&lang=js&"
export * from "./UserView.vue?vue&type=script&lang=js&"
import style0 from "./UserView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserView.vue?vue&type=style&index=1&id=536d8c3b&scoped=true&lang=css&"
import style2 from "./UserView.vue?vue&type=style&index=2&id=536d8c3b&scoped=true&lang=css&"
import style3 from "./UserView.vue?vue&type=style&index=3&id=536d8c3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d8c3b",
  null
  
)

export default component.exports